import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledEventsMenu } from 'shell/view-models/disabled-menu';

interface EventsMenuProps {
  visibility?: DisabledEventsMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const EventsMenu = ({
  visibility = {
    eventType: true,
    subscriber: true,
    eventRegistration: true,
    destinationType: true,
    searchPublishedEvents: true,
    searchEventsInError: true,
    managementNonRecoverableErrors: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: EventsMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Event Manager" />
      </ListItem>
      <Menu
        id="event-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.eventType
          ? [
              <MenuItem
                key="eventtype-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/tipievento');
                }}
              >
                <Typography variant="inherit">Tipi Evento</Typography>
              </MenuItem>,
              <Divider key="tipoevento-divider" hidden={!visibility.eventRegistration} />,
            ]
          : undefined}
        {visibility.destinationType
          ? [
              <MenuItem
                key="destinationtype-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/tipidestinazione');
                }}
              >
                <Typography variant="inherit">Tipi Destinazione</Typography>
              </MenuItem>,
              <Divider key="tipodestinazione-divider" hidden={!visibility.subscriber} />,
            ]
          : undefined}
        {visibility.subscriber
          ? [
              <MenuItem
                key="subscriber-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/sottoscrittore');
                }}
              >
                <Typography variant="inherit">Sottoscrittore</Typography>
              </MenuItem>,
              <Divider key="sottoscrittore-divider" hidden={!visibility.searchPublishedEvents} />,
            ]
          : undefined}
        {visibility.eventRegistration
          ? [
              <MenuItem
                key="eventRegistration-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/iscrizione-evento');
                }}
              >
                <Typography variant="inherit">Iscrizione Evento</Typography>
              </MenuItem>,
              <Divider key="iscrizioneevento-divider" hidden={!visibility.searchEventsInError} />,
            ]
          : undefined}
        {visibility.searchPublishedEvents
          ? [
              <MenuItem
                key="publishedEvents-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/ricerca-eventi-pubblicati');
                }}
              >
                <Typography variant="inherit">Ricerca Eventi Pubblicati</Typography>
              </MenuItem>,
              <Divider
                key="ricercaeventipubblicati-divider"
                hidden={!visibility.searchEventsInError}
              />,
            ]
          : undefined}
        {visibility.searchEventsInError
          ? [
              <MenuItem
                key="errorEvents-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/ricerca-eventi-in-errore');
                }}
              >
                <Typography variant="inherit">Ricerca Eventi In Errore</Typography>
              </MenuItem>,
              <Divider
                key="ricercaeventinerrore-divider"
                hidden={!visibility.managementNonRecoverableErrors}
              />,
            ]
          : undefined}
        {visibility.managementNonRecoverableErrors
          ? [
              <MenuItem
                key="nonRecoverableEvent-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/eventmanager/gestione-errori-non-recuperabili');
                }}
              >
                <Typography variant="inherit">Gestione errori non recuperabili</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

EventsMenu.displayName = 'Events Menu';

export default EventsMenu;
